module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-radiogroup"]
  }, [(_vm.show) ? _c('dof-mask', {
    on: {
      "click": _vm.layoutClick
    }
  }) : _vm._e(), (_vm.show) ? _c('div', {
    ref: "radiogroupBox",
    staticClass: ["dof-radiogroup-box"],
    style: {
      bottom: '-' + _vm.height + 'px'
    }
  }, [_c('scroller', {
    staticClass: ["dof-radiogroup-content"],
    style: {
      height: _vm.height - 28 + 'px'
    },
    attrs: {
      "showScrollbar": "false"
    }
  }, [_c('div', {
    staticClass: ["dof-radiogroup-item-wrapper"],
    style: {
      'min-height': _vm.height - 28 + 'px'
    }
  }, _vm._l((_vm.items), function(item, i) {
    return _c('div', {
      key: i,
      ref: 'item' + i,
      refInFor: true,
      staticClass: ["dof-radiogroup-item"],
      on: {
        "click": function($event) {
          _vm.radiogroupItemClick(item, i, item[_vm.keyField])
        }
      }
    }, [_c('div', {
      staticClass: ["icon-wrapper"]
    }, [(_vm.index == i && _vm.isShowIcon) ? _c('image', {
      staticClass: ["item-icon"],
      attrs: {
        "src": _vm.radioIcon
      }
    }) : _vm._e()]), _c('text', {
      staticClass: ["item-text"],
      style: {
        color: _vm.color(item, i)
      }
    }, [_vm._v(_vm._s(_vm.display(item)))])])
  }))]), _c('div', {
    staticClass: ["dof-radiogroup-bottom"]
  }, [_c('text', {
    staticClass: ["btn-grp-text", "btn-cancel"],
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("取消")]), _c('text', {
    staticClass: ["btn-grp-text", "btn-confirm"],
    on: {
      "click": _vm.confirmClick
    }
  }, [_vm._v("确定")])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-043f9315!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-select/index.vue
// module id = 569
// module chunks = 0 1